import * as React from 'react';
import { ISummaryItem } from '../../../models';
import { RowSummaryItem } from './RowSummaryItem';

export enum EmailSummaryItemType {
	SubjectLine = 'SubjectLine',
	ReplyTo = 'ReplyTo',
	HtmlEnabled = 'HtmlEnabled',
	EmailContent = 'EmailContent',
	EmailName = 'EmailName',
	SendDate = 'SendDate',
}

export class EmailSummaryItem extends React.Component<ISummaryItem> {
	public render() {
		const hasScrollableContent = this.props.propertyName === EmailSummaryItemType.EmailContent;
		return <RowSummaryItem {...this.props} hasScrollableContent={hasScrollableContent} />;
	}
}
